// extracted by mini-css-extract-plugin
export var root = "Code-module--root--2p9w3";
export var code = "Code-module--code--LIDp-";
export var inline = "Code-module--inline--3H9P9";